export default __webpack_public_path__ + "static/media/giraffe-orange.5f13b4a7.svg";